import {CloseOutlined} from '@ant-design/icons';
import {Button, Drawer, Menu, Modal} from 'antd';
import {PropTypes} from 'prop-types';
import {useState} from 'react';

import {FilterOptions} from './FilterOptions';

const FilteredProducts = ({sortOption, setSortOption, filters, setFilters, resetFilters}) => {
  const [visibleSortModal, setVisibleSortModal] = useState(false);

  const [visibleFilterModal, setVisibleFilterModal] = useState(false);

  const sortOptions = [
    {label: 'New Arrivals', value: 'new'},
    {label: 'Price: Low to High', value: 'lowToHigh'},
    {label: 'Price: High to Low', value: 'highToLow'},
  ];

  const handleSortOk = () => {setVisibleSortModal(false);};

  const handleSortCancel = () => {setVisibleSortModal(false);};

  const handleSortOptionChange = option => {
    setSortOption(option);
    setVisibleSortModal(false);
  };

  const handleSortClick = () => {setVisibleSortModal(true);};

  const handleFilterClick = () => {setVisibleFilterModal(true);};

  const handleFilterCancel = () => {setVisibleFilterModal(false);};

  return (
    <div className={'w-full flex justify-between lg:mx-auto lg:px-3 mb-3'}>
      <Button
        color={'default'}
        variant={'outlined'}
        className={'lg:text-sm font-semibold lg:w-32 w-24 border-2 border-solid !border-primary-900 rounded-lg !text-black shadow-sm hover:shadow-primary-900'}
        onClick={handleFilterClick}
      >
        Filters
      </Button>

      <Drawer
        title={(
          <div className={'flex justify-between items-center w-full'}>
            <h1 className={'text-primary-900 text-lg font-serif-custom'}>Filters</h1>
            <Button
              type={'text'}
              icon={<CloseOutlined className={'text-primary-950'} />}
              onClick={handleFilterCancel}
              className={'cursor-pointer overflow-y-auto'}
            />
          </div>
        )}
        placement={'left'}
        closable={false}
        visible={visibleFilterModal}
        width={350}
      >
        <div>
          <FilterOptions filters={filters} setFilters={setFilters} resetFilters={resetFilters} />
        </div>
      </Drawer>

      <div>
        <Button
          color={'default'}
          variant={'outlined'}
          className={'text-sm font-semibold lg:w-48  border-2 border-solid !border-[#3D180F] rounded-lg !text-black shadow-sm hover:shadow-primary-900'}
          onClick={handleSortClick}
        >
          Sort : {sortOption}
        </Button>
        <Modal
          title={<span className={'text-primary-900 font-serif-custom text-lg'}>Sort By</span>}
          visible={visibleSortModal}
          onOk={handleSortOk}
          onCancel={handleSortCancel}
          footer={null}
          width={300}
          className={'lg:left-80 lg:top-36 xl:top-56 xl:left-96'}
        >
          <div className={'mt-5 text-sm font-semibold'}>
            <Menu>
              {sortOptions.map(option => (
                <Menu.Item key={option.value} onClick={() => handleSortOptionChange(option.label)}>
                  {option.label}
                </Menu.Item>
              ))}
            </Menu>
          </div>
        </Modal>
      </div>
    </div>
  );
};

FilteredProducts.propTypes = {
  sortOption: PropTypes.string,
  setSortOption: PropTypes.func,
  filters:PropTypes.array,
  setFilters:PropTypes.func,
  resetFilters:PropTypes.func,
};

export default FilteredProducts;
